export class WeeklyPlanningAction {
    public id: number = 0;
    public idweeklyplanning: number = 0;
    public day: number = 0;
    public progressivetime: number = 0;
    public commands: string = "";
}
